module.exports = __webpack_public_path__ + "img/Khervie00_logo.a9930492.png";